import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import { and, eq } from 'ember-truth-helpers';
import UiCard from 'garaje/components/ui/card';

interface SortableColumnHeaderSignature {
  Args: {
    sortBy: string;
    sortDirection: string;
    isActive: boolean;
    setSortDirection?: (direction: string) => void;
    setSortBy?: (sortBy: string) => void;
    sortOptions: string[];
  };
  Blocks: {
    title?: [];
  };
  Element: HTMLDivElement;
}

export default class SortableColumnHeader extends Component<SortableColumnHeaderSignature> {
  @action
  selectSortBy(sortDirection: string, closeFn: () => void): void {
    const { sortBy, setSortDirection, setSortBy } = this.args;

    setSortDirection?.(sortDirection);
    setSortBy?.(sortBy);
    closeFn();
  }

  <template>
    <div ...attributes data-test-sortable-col>
      <BasicDropdown as |dropdown|>
        <dropdown.Trigger>
          <div style="cursor: pointer" class="flex">
            {{#if @isActive}}
              <span data-test-sortable-col-header data-test-sortable-col-header-active>
                {{#if (has-block "title")}}
                  {{yield to="title"}}
                {{else}}
                  {{@sortBy}}
                {{/if}}
              </span>
              <img class="pl-2" src="/assets/images/chevron-down.svg" alt="down arrow, active" />
            {{else}}
              <span class="text-carbon-50" data-test-sortable-col-header>
                {{#if (has-block "title")}}
                  {{yield to="title"}}
                {{else}}
                  {{@sortBy}}
                {{/if}}
              </span>
              <img class="pl-2" src="/assets/images/chevron-down-gray.svg" alt="down arrow, inactive" />
            {{/if}}
          </div>
        </dropdown.Trigger>
        <dropdown.Content>
          <UiCard class="powerSelect-radio ember-power-select-options shadow">
            <div class="font-bold uppercase p-2 ml-4 text-carbon-40" style="font-size: 10px; height: 26px;">
              sort
            </div>
            {{#each @sortOptions as |option|}}
              {{! template-lint-disable no-unsupported-role-attributes }}
              <li
                aria-selected={{if (and @isActive (eq @sortDirection option)) "true" "false"}}
                class="text-xs ember-power-select-option"
                role="button"
                {{on "click" (fn this.selectSortBy option dropdown.actions.close)}}
                data-test-sort-by
              >
                {{option}}
              </li>
            {{/each}}
          </UiCard>
        </dropdown.Content>
      </BasicDropdown>
    </div>
  </template>
}
